package dairy.mynotes.navigation

/**
 * Sealed class representing all screens/destinations in the app
 * Each screen has a unique route string for navigation
 */
sealed class Screen(val route: String) {

    // Authentication Screens
    data object Login : Screen("login")
    data object Registration : Screen("registration")

    // Main App Screens
    data object NotesList : Screen("notes_list")
    data object AddNote : Screen("add_note")

    // Note Detail/Edit Screens
    data object UpdateNote : Screen("update_note/{noteId}/{isEditMode}") {
        fun createRoute(noteId: String, isEditMode: Boolean) = "update_note/$noteId/$isEditMode"
    }

    data object UpdateCategory : Screen("update_category/{categoryId}") {
        fun createRoute(categoryId: String) = "update_category/$categoryId"
    }

    // Additional Screens (examples)
    data object NoteDetail : Screen("note_detail/{noteId}") {
        fun createRoute(noteId: String) = "note_detail/$noteId"
    }



    companion object {
        /**
         * Get all authentication screens
         */
        fun getAuthScreens() = listOf(Login, Registration)

        /**
         * Get all main app screens (after login)
         */
        fun getMainScreens() = listOf(NotesList, AddNote)
    }
}

